import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LangProvider } from './i18n';
import { installGlobalErrorReporter } from './lib/clientErrorReporter';

// Wire window.onerror + unhandledrejection → POST /api/client-errors so we can
// see failures hitting real Tanzanian users on flaky 3G without paying for Sentry.
installGlobalErrorReporter();

const rootEl = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <HelmetProvider>
      <LangProvider>
        <App />
      </LangProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();

// Register the service worker so Chrome Desktop will offer PWA install.
// Guarded to production-like HTTPS contexts so the dev preview isn't affected.
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // Don't break the app if SW registration fails; just log.
        // eslint-disable-next-line no-console
        console.warn('SW registration failed:', err);
      });
  });
}
